module.exports = __webpack_public_path__ + "img/molloco.80bdf872.jpg";